var exports = {
  "x6": "MemberListItem.module__button___SzFXT0",
  "OG": "MemberListItem.module__nameRoleColored___SzFXT0",
  "w1": "MemberListItem.module__buttonOffline___SzFXT0",
  "dP": "MemberListItem.module__buttonContextMenuOpen___SzFXT0",
  "vs": "MemberListItem.module__memberFocusRing___SzFXT0",
  "Vg": "MemberListItem.module__grid___SzFXT0",
  "Qs": "MemberListItem.module__content___SzFXT0",
  "H": "MemberListItem.module__avatarContainer___SzFXT0",
  "TT": "MemberListItem.module__userInfoContainer___SzFXT0",
  "VW": "MemberListItem.module__nameContainer___SzFXT0",
  "UU": "MemberListItem.module__name___SzFXT0",
  "w4": "MemberListItem.module__memberCustomStatus___SzFXT0",
  "Dd": "MemberListItem.module__ownerIcon___SzFXT0",
  "j$": "MemberListItem.module__crownIcon___SzFXT0",
  "a1": "MemberListItem.module__userTag___SzFXT0",
};

module.exports = exports;
